import {get} from 'lodash'
import moment from 'moment'

export default {
  methods: {
    generateBodyForward (mail, prefix) {
      const from = get(mail, 'from.name', '')
      const emailFrom = get(mail, 'from.email', '')
      const date = get(mail, 'date', '')
      const dateFormat = date ? moment(date).format('DD-MMM-YY, HH:mm') : ''
      const subject = get(mail, 'subject', '')
      const to = get(mail, 'to.name', '')
      const emailTo = get(mail, 'to.email', '')
      const body = get(mail, 'msg', '')
      const attachments = get(mail, 'attachments', [])
      const attachmentsInset = get(mail, 'attachmentsInset', [])
      const contentsHTML = [
        '---------- Forwarded message ---------',
        '<br>',
        `From: <b>${from}</b> &#60;<a href="mailto:${emailFrom}">${emailFrom}</a>&#62;`,
        '<br>',
        `Date: ${dateFormat}`,
        '<br>',
        `Subject: ${subject}`,
        '<br>',
        `To: ${to} &#60;<a href="mailto:${emailTo}">${emailTo}</a>&#62;`,
        '<br>',
        '<br>',
        `${body}`
      ]
      return {
        toEmail: emailTo,
        fromEmail: emailFrom,
        subject: `${prefix || ''} ${subject}`,
        contentsHTML: contentsHTML.join(''),
        attachments: attachments,
        attachmentsInset: attachmentsInset
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/generateBodyForward.js